import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Image, Checkbox } from '@gik/ui';

export interface IEventServicesTileProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  image: string;
  compact?: boolean; // compact will hide text for unselected tiles
  selected?: boolean;
  horizontal?: boolean;
  multiple?: boolean;
}

export function EventServicesTile({
  image,
  label,
  selected,
  horizontal,
  multiple,
  compact,
  className,
}: IEventServicesTileProps) {
  const bem = bemBlock('event-services-tile');

  return (
    <div className={bem(null, [{ horizontal }, { vertical: !horizontal }, { selected }, { compact }], className)}>
      <Image className={bem('image')} src={image} />
      <span className={bem('label')}>{label}</span>

      {multiple && <Checkbox checked={selected} />}
    </div>
  );
}
